export default "__VITE_ASSET__DIbW4dRX__"